module.exports = __webpack_public_path__ + "img/share_theme.a6665083.jpg";